/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Detail_Sign_In_Not_AcceptedInputs */



/**
* | output |
* | --- |
* | "Invitation not yet accepted" |
*
* @param {Member_Detail_Sign_In_Not_AcceptedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_detail_sign_in_not_accepted = /** @type {((inputs?: Member_Detail_Sign_In_Not_AcceptedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Detail_Sign_In_Not_AcceptedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einladung noch nicht angenommen")
	return /** @type {LocalizedString} */ ("Invitation not yet accepted")
});